// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://sepolia.arbiscan.io/address/0x5f4d15d761528c57a5C30c43c1DAb26Fc5452731
export const TRANSPARENT_PROXY_FACTORY = '0x5f4d15d761528c57a5C30c43c1DAb26Fc5452731';

// https://sepolia.arbiscan.io/address/0xCB5B3ca20603231945dC5731C33E7f7F7679Ea89
export const PROXY_ADMIN = '0xCB5B3ca20603231945dC5731C33E7f7F7679Ea89';

// https://sepolia.arbiscan.io/address/0xb13Cfa6f8B2Eed2C37fB00fF0c1A59807C585810
export const GHO_TOKEN = '0xb13Cfa6f8B2Eed2C37fB00fF0c1A59807C585810';

export const CHAIN_ID = 421614;
